import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "token-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLimitVisible)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          "model-value": _ctx.itemPerPage,
          class: "token-pagination__select",
          size: "small",
          onChange: _ctx.changeItemPerPage
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DEFAULT_PAGE_SIZE_LIST, (size) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: size,
                label: `${size} / page`,
                value: size,
                class: "token-pagination__option"
              }, null, 8 /* PROPS */, ["label", "value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model-value", "onChange"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      _createVNode(_component_el_button, {
        disabled: !_ctx.hasPrevPage,
        icon: _ctx.icons.DArrowLeft,
        size: "small",
        type: "primary",
        text: "",
        class: "token-pagination__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePageHandler(_ctx.TokenPaginationEvent.RESET_PAGINATION)))
      }, null, 8 /* PROPS */, ["disabled", "icon"]),
      _createVNode(_component_el_button, {
        disabled: !_ctx.hasPrevPage,
        icon: _ctx.icons.ArrowLeft,
        size: "small",
        type: "primary",
        text: "",
        class: "token-pagination__button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePageHandler(_ctx.TokenPaginationEvent.PREV_PAGE)))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Previous ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "icon"]),
      _createVNode(_component_el_button, {
        disabled: !_ctx.hasNextPage,
        size: "small",
        type: "primary",
        text: "",
        class: "token-pagination__button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePageHandler(_ctx.TokenPaginationEvent.NEXT_PAGE)))
      }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createTextVNode(" Next ", -1 /* CACHED */)),
          _createVNode(_component_el_icon, { class: "token-pagination__icon" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.ArrowRight)))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ])
  ]))
}